export const getAutresAustralieData = () => ({
  name: "Autres régions d'Australie",
  country: "Australie",
  description: "L'Australie compte de nombreuses autres régions viticoles importantes, chacune avec ses caractéristiques uniques. Ces régions contribuent à la diversité et à la richesse du paysage viticole australien.",
  type: "region",
  mapAreas: [
    { region: "Riverland", x: 35, y: 82, color: "#f0f0f0", size: 2 },
    { region: "Riverina", x: 50, y: 75, color: "#f0f0f0", size: 2 },
    { region: "Langhorne Creek", x: 41, y: 83, color: "#f0f0f0", size: 1 },
    { region: "Padthaway", x: 36, y: 86, color: "#f0f0f0", size: 1 },
    { region: "Wrattonbully", x: 37, y: 87, color: "#f0f0f0", size: 1 }
  ],
  statistics: {
    totalArea: "55,000 ha (ensemble)",
    production: "8.5 million hectolitres",
    appellations: "Diverses GI",
    subregions: "Régions multiples",
    exportPercentage: "70%"
  },
  characteristics: {
    climate: "Climats très variés : méditerranéen, continental, océanique",
    soil: "Sols divers : calcaires, argileux, sableux, excellente diversité géologique",
    viticulture: "Innovation technologique, viticulture durable, rendements contrôlés"
  },
  wineStyles: {
    red: "Vins rouges variés : puissants, élégants, fruités selon les régions",
    white: "Vins blancs variés : frais, aromatiques, complexes selon les régions",
    rose: "Rosés fruités et accessibles",
    sparkling: "Vins effervescents de méthode traditionnelle et Charmat"
  },
  history: "Ces régions représentent la diversité viticole australienne, avec des histoires et des traditions variées. Elles contribuent à la richesse et à l'innovation du paysage viticole national.",
  foodPairing: "Cuisine australienne diverse : barbecue, fruits de mer, viandes, cuisine fusion."
}); 